module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/pill-group/pill-group.component.scss
// module id = ./src/app/modules/common-module/components/pill-group/pill-group.component.scss
// module chunks = 9